import { addNotify } from 'features/notify';

const actionTypes = {
  ACTION_PROCESSING: 'reports/ACTION_PROCESSING',
  GET_STATISTIC_PROVIDER: 'reports/GET_STATISTIC_PROVIDER',
};

function getStatisticProvider(form) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

    const response = await api.generalReport.getStatisticProvider(form);

    if (response.success) {
      dispatch({
          type: actionTypes.GET_STATISTIC_PROVIDER,
          payload: response.data,
        });
      } else {
        const { locale } = getState().locale;
        let errorMessage = locale[response.codeStatus] ?? (response.errorMessage || locale.defaultMessage);
        if (response.errorMessage === 'Execution timeout') errorMessage = locale.defaultMessage;
        if (response.errorMessage.includes('validation error')) errorMessage = locale.validationError;
        dispatch(addNotify(errorMessage, 'error'));
      }

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
  };
}

export {
  actionTypes,
  getStatisticProvider,
};
